import React from 'react';
import Button from '@mui/material/Button';

function FAQ() {
  return (
    <div>
        <h2>Frequently Asked Questions</h2>

        <h3 style={{fontSize: 22}}>Q: How do I earn Leviathan (LVTN)?</h3>
        <p style={{paddingLeft: 16, paddingRight: '24vw'}}>
            A: LVTN is earned passively by NFT holders. Once per week, the following
            amount is airdropped to holders based on the property type of the NFT.
            <ul>
                <li>Colonial - 1.2</li>
                <li>Single Family Home (SFH) - 1</li>
                <li>Contemporary - 0.8</li>
                <li>French Provincial (FP) - 1.5</li>
                <li>Apartments - 2.5</li>
                <li>Store - 2</li>
                <li>Shack - 0.5</li>
            </ul>
            Owners of multiple NFTs will get a sum of all the properties they own. 
        </p>
        <h3 style={{fontSize: 22}}>Q: How do I presale mint?</h3>
        <p style={{paddingLeft: 16, paddingRight: '24vw'}}>
          A: Presale minting can be done by people with the whitelist token (LVTN). Contact me through twitter of discord to apply for the whitelist, or fill out this <Button variant="contained" color='success' href='https://forms.gle/vRpbEQYWvfdutJvG9'>FORM</Button>.
          If you are chosen you will be airdropped 1 $LVTN, allowing you to presale mint.
        </p>
    </div>
  )
}

export default FAQ